/**
 * Fabpad product card — colour swatches, AJAX add to bag.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return String(window.Shopify.formatMoney(cents)).replace(/\.00(?!\d)/, '');
    }
    return '₹' + Math.round(cents / 100);
  }

  function getSaveLabel(price, compareAt) {
    if (!compareAt || compareAt <= price) return '';
    var pct = Math.round(((compareAt - price) / compareAt) * 100);
    return 'SAVE ' + pct + '%';
  }

  function findVariant(variants, colorKey, colorValue) {
    return variants.find(function (variant) {
      return String(variant[colorKey] || '').toLowerCase() === String(colorValue).toLowerCase();
    });
  }

  function applyVariant(card, variant) {
    if (!variant) return;

    var variantInput = card.querySelector('[data-variant-id]');
    if (variantInput) variantInput.value = variant.id;

    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var compareEl = card.querySelector('[data-card-compare]');
    var saveEl = card.querySelector('[data-card-save]');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (saveEl) {
      var saveLabel = getSaveLabel(variant.price, variant.compare_at_price);
      saveEl.textContent = saveLabel;
      saveEl.hidden = !saveLabel;
    }

    var primaryImg = card.querySelector('.fabpad-pcard__image--primary');
    if (primaryImg && variant.image) {
      primaryImg.src = variant.image;
      primaryImg.srcset = '';
    }

    var productLinks = card.querySelectorAll('[data-card-product-link]');
    if (variant.url) {
      productLinks.forEach(function (link) {
        link.href = variant.url;
      });
    }

    var atc = card.querySelector('[data-fabpad-atc]');
    if (atc) {
      if (variant.available) {
        atc.disabled = false;
        atc.classList.remove('fabpad-pcard__atc--oos');
        atc.textContent = atc.dataset.labelDefault || 'Add to bag';
      } else {
        atc.disabled = true;
        atc.classList.add('fabpad-pcard__atc--oos');
        atc.textContent = 'Back soon';
      }
    }
  }

  function initSwatches(card) {
    var variantsEl = card.querySelector('[data-product-variants]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    var colorKey = card.dataset.colorOption || 'option1';
    var swatches = card.querySelectorAll('[data-swatch-color]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        swatches.forEach(function (s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');

        var variant = findVariant(variants, colorKey, swatch.dataset.swatchColor);
        if (!variant) {
          variant = variants.find(function (v) {
            return v.available;
          }) || variants[0];
        }
        applyVariant(card, variant);
      });
    });
  }

  function initAddToCart(card) {
    var btn = card.querySelector('[data-fabpad-atc]');
    var variantInput = card.querySelector('[data-variant-id]');
    if (!btn || !variantInput || btn.classList.contains('fabpad-pcard__atc--oos')) return;

    btn.dataset.labelDefault = btn.textContent.trim();

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      if (btn.disabled || btn.classList.contains('fabpad-pcard__atc--oos')) return;

      var variantId = variantInput.value;
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.remove('is-success', 'is-error');
      btn.classList.add('is-loading');
      btn.textContent = 'Adding...';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function (data) {
          var after = window.FabpadCart && window.FabpadCart.afterAdd
            ? window.FabpadCart.afterAdd(data)
            : Promise.resolve();

          return after.then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
            btn.textContent = 'Added ✓';

            window.setTimeout(function () {
              btn.classList.remove('is-success');
              btn.textContent = btn.dataset.labelDefault;
              btn.disabled = false;
            }, 1500);
          });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.textContent = 'Try again';
          btn.disabled = false;

          window.setTimeout(function () {
            btn.classList.remove('is-error');
            btn.textContent = btn.dataset.labelDefault;
          }, 2000);
        });
    });
  }

  function initCard(card) {
    if (card.dataset.cardInitialized === 'true') return;
    card.dataset.cardInitialized = 'true';
    initSwatches(card);
    if (!card.hasAttribute('data-kit-card')) {
      initAddToCart(card);
    }
  }

  window.FabpadProductCard = {
    init: function (root) {
      var scope = root || document;
      scope.querySelectorAll('[data-product-card]').forEach(initCard);
    }
  };

  window.FabpadProductCard.init();
})();
